import { render } from "./GaleryComponent.vue?vue&type=template&id=76ea5fe6&scoped=true"
import script from "./GaleryComponent.vue?vue&type=script&lang=js"
export * from "./GaleryComponent.vue?vue&type=script&lang=js"

import "./GaleryComponent.vue?vue&type=style&index=0&id=76ea5fe6&scoped=true&lang=css"
import "./GaleryComponent.vue?vue&type=style&index=1&id=76ea5fe6&lang=css"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ea5fe6"]])

export default __exports__